import { BaseDevice, CustomLayout } from '../base_device'
import { generateArray } from '@/tool/utility'
import { getDeviceKeySquare } from './keysquare/keysquare'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import list_icon from '@/assets/img/device/li75/list_icon.png'
import { li75VKCodes } from './keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
//重置键盘方法：按住Esc键，拔掉键盘重新插入，然后松开Esc键，再次拔掉键盘重新插入。
export class LI75 extends BaseDevice {
  speedAllowValues: number[] = generateArray(0, 256)
  lightAllowValues: number[] = generateArray(0, 256)

  resetDes: string = 'recovery_notice_li75'
  isQMKDevice = true
  square = getDeviceKeySquare(DevicePid.IROKQMKLi75)
  name: string = 'LI75_PRO'
  icon: string = list_icon
  width: number = 646
  y_number: number = 10
  fnDisableKeys: KK[] = [0x050a, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 257, 258, 259, 260, 265, 266, 267, 268, 270, 526, 782, 1038]
  inoperableKeys: KK[] = [0x50a]
  vkcodes = li75VKCodes
  absoluteKey: CustomLayout = {
    0x40d: this.createSquare(540, 4),
    0x50c: this.createSquare(503, 4),
    0x50d: this.createSquare(540, 4),
    0x50e: this.createSquare(578, 4),
  }
  customLayout: CustomLayout = {
    0x2: this.createSquare(10, 2),
    0x6: this.createSquare(8, 2),
    0xa: this.createSquare(8, 2),
    0x100: this.createSquare(2, this.y_number),
    0x101: this.createSquare(2, this.y_number),
    0x102: this.createSquare(2, this.y_number),
    0x103: this.createSquare(2, this.y_number),
    0x104: this.createSquare(2, this.y_number),
    0x105: this.createSquare(2, this.y_number),
    0x106: this.createSquare(2, this.y_number),
    0x107: this.createSquare(2, this.y_number),
    0x108: this.createSquare(2, this.y_number),
    0x109: this.createSquare(2, this.y_number),
    0x10a: this.createSquare(2, this.y_number),
    0x10b: this.createSquare(2, this.y_number),
    0x10c: this.createSquare(2, this.y_number),
    0x10d: this.createSquare(2, this.y_number, 65),
    0x10e: this.createSquare(19, this.y_number),
    0x200: this.createSquare(2, 2, 50),
    0x20d: this.createSquare(2, 2, 52),
    0x20e: this.createSquare(19, 2),
    0x300: this.createSquare(2, 2, 65),
    0x30d: this.createSquare(2, 2, 75),
    0x30e: this.createSquare(19, 2),
    0x400: this.createSquare(2, 2, 80),
    0x40c: this.createSquare(2, 2, 62),
    0x40e: this.createSquare(56, 2),
    0x500: this.createSquare(2, 2, 47.5),
    0x501: this.createSquare(2, 2, 47.5),
    0x502: this.createSquare(2, 2, 47.5),
    0x506: this.createSquare(2, 2, 192),
    0x509: this.createSquare(2, 2, 47.5),
    0x50a: this.createSquare(2, 2, 47.5),
    0x50b: this.createSquare(2, 2, 47.5),
  }
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {
    [LightEffectMode.Monochrome]: 1,
    [LightEffectMode.VerticalGradient]: 2,
    [LightEffectMode.TransparentGradient]: 3,
    [LightEffectMode.BreathingRhythm]: 4,
    [LightEffectMode.SaturatedStyle]: 5,
    [LightEffectMode.BrightBeauty]: 6,
    [LightEffectMode.SaturatedWindmill]: 7,
    [LightEffectMode.BrightWindmill]: 8,
    [LightEffectMode.SaturatedSpiral]: 9,
    [LightEffectMode.BrightSpiral]: 10,
    [LightEffectMode.AllCycle]: 11,
    [LightEffectMode.HorizontalCycle]: 12,
    [LightEffectMode.VerticalCycle]: 13,
    [LightEffectMode.RainbowCluster]: 14,
    [LightEffectMode.InnerOuterCycle]: 15,
    [LightEffectMode.BidirectionalCycle]: 16,
    [LightEffectMode.WindmillCycle]: 17,
    [LightEffectMode.SpiralCycle]: 18,
    [LightEffectMode.DoubleBeacon]: 19,
    [LightEffectMode.RainbowBeacon]: 20,
    [LightEffectMode.RainbowWindmill]: 21,
    [LightEffectMode.Raindrop]: 22,
    [LightEffectMode.CandyRaindrop]: 23,
    [LightEffectMode.HueBreathing]: 24,
    [LightEffectMode.HuePendulum]: 25,
    [LightEffectMode.HueWave]: 26,
    [LightEffectMode.PixelRain]: 27,
    [LightEffectMode.PixelFlow]: 28,
    [LightEffectMode.PixelFractal]: 29,
    [LightEffectMode.TypingHeatmap]: 30,
    [LightEffectMode.SimpleResponse]: 31,
    [LightEffectMode.GeneralResponse]: 32,
    [LightEffectMode.WideResponse]: 33,
    [LightEffectMode.MultiWideResponse]: 34,
    [LightEffectMode.CrossResponse]: 35,
    [LightEffectMode.MultiCross]: 36,
    [LightEffectMode.CenterResponse]: 37,
    [LightEffectMode.MultiCenter]: 38,
    [LightEffectMode.Splash]: 39,
    [LightEffectMode.MultiSplash]: 40,
  }
}
